// hooks/useSwitchBack.js
import jwtAxios from '@projectK/services/auth/JWT';
import { useInfoViewActionsContext } from '@projectK/context/InfoViewContextProvider';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import PopupDialog from '@projectK/modules/apps/PopupDialog';

export const useSwitchBack = () => {
  const infoViewActionsContext = useInfoViewActionsContext();
  const { isMobile } = useMobileSettings();
  const navigate = useNavigate();
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);

  const switchBack = async ({
    id,
    role,
    actualRole,
    actualUser,
    parentuser,
    parentuserRoleId,
    isDeleted,
    openInBlankWindow,
  }) => {
    try {
      if (isDeleted) {
        setIsDeleted(true)
        setIsErrorDialogOpen(true);
      } else {
        await jwtAxios.post(`/admin/switch-user`, {
          selectedUserId: id,
          role,
          actualRole,
          actualUser,
          parentuser,
          parentuserRoleId,
          isMobile: isMobile ?? null,
        });
        if (isMobile) {
          navigate(0);
        } else if(openInBlankWindow){
          window.open('_blank');
        }else {
          window.location.reload();
        }
      }
    } catch (error) {
      console.error(error);
      if (error?.response?.data?.error === 'Selected user is Inactive.') {
        setIsErrorDialogOpen(true);
      }
      infoViewActionsContext.fetchError(
        error.response?.data?.error || 'Something went wrong',
      );
    }
  };
  const DialogRenderer = () =>
    isErrorDialogOpen ? (
      <PopupDialog
        setIsErrorDialogOpen={setIsErrorDialogOpen}
        isErrorDialogOpen={isErrorDialogOpen}
        isDeleted={isDeleted}
      />
    ) : null;

  return { switchBack, DialogRenderer };
};
